import { useState, useEffect, useMemo, useRef } from 'react';
import Drawer from '@mui/material/Drawer';
import useStateWithCallback from 'use-state-with-callback';
import { Helmet } from 'react-helmet';
import {ElementInfo} from './ElementInfo'
import { getDataSource } from '../api/ds';  // Метод получения описателя для drag end drop мню
import useOn from './socketLib/UseOn';
import { useLocalNotifications } from './Events';
import { Box, ListItem, Tabs } from '@mui/material';
import _, { identity } from 'lodash';
import Scrollbars from "rc-scrollbars";
import { post } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import { ShowModal } from "components/Modal";
import { DNDTab, StyledTab } from 'utils/formatters';
import Loading from './Load';
import MoveGuideDialog from './MoveGuideDialog';



/*Это основной элемент drag end drop меню, в нём происходит получение данных и последующая отрисовка компоментов свего меню 
Drag and drop имеет следующую структуру

./src
    ./api
        ./apiBridges 
            ./dndBridge.js  (Бриджи для дескриптора)
        ./descriptors
            ./addressableStorage.js (Дескрипторы)
    ./components
        ./DragDrop.js (Основной элемент drag end drop)
    ./utils
        ./dndutils
            ./cardformatters.js (Форматеры тикетов)
            ./containerformatters.js  (Форматеры контейнеров)
            ./staticresorces.js (Статические ресурсы)
            ./toppanelformaters.js  (Форматеры панелей фильтров)

Для создания нового элемента он размещается в соответствующем файле, после чего вкладывается в дескриптор, который работает как конструктор для данного меню
*/


export const DragAndDrop = ({ ds }) => {

  const [emitflag, setEmitFlag] = useState(false); // Флаг используемый для предотвращения рендера при обновлении данных. Он должен использоваться при обновлении данных через сокет
  // const [listItems, setListItems] = useStateWithCallback({order:[], items:{}}, listItems => {if (emitflag) {ds['set_order_' + ds.descr.id](listItems.order); setEmitFlag(false);}}) // Список отображаемых элементов
  // const [listTables, setListTables] = useStateWithCallback(ds['get_tables_' + ds.descr.id](), listTables => {ds['set_tables_' + ds.descr.id](listTables);setEmitFlag(false)}) // Список отображаемых таблиц
  /** @type {[any, Function]} */ 
  const [listItems, setListItems] = useStateWithCallback({order:[], items:{}}, listItems => {setEmitFlag(false);}) // Список отображаемых элементов
  /** @type {[Array<any>, Function]} */ 
  const [listTables, setListTables] = useStateWithCallback([], listTables => { setEmitFlag(false)}) // Список отображаемых таблиц
  
  const [tab, setTab] = useState(localStorage.getItem("AST") || 0)//Таким образом можем выбирать вкладки
  const [tabList, setTabsList] = useState([])
  const [loading, setLoading] = useState(true)


  const eids = getDataSource(ds.descr.EIDS)
  const [unsavedChanges, setUnsavedChanges] = useState(false);

  const { user_id, company_id, rules} = useSelector(
        loginSelector
    );

  console.log('COMPANY ID', company_id)

  const isSameCompany = (data, company_id) => {
    if (!Array.isArray(data)) return false;


    //Ломается, когдп прилетает пустой массив

    return data[0].company_id === company_id

    //Нихера не понял, зачем лиза так это сделала
    // return data.some(item =>
    //   item?.content?.managers?.some(m => m?.company_id === company_id)
    // );
  };

  useOn('get_order_dnd_' + ds.descr.id , (data) => {
    // если есть items — проверим через них

    if (data.company_id !== company_id) {
      console.log('SKIP order: wrong company');
      return;
    }

    console.log("get_order_dnd_", data)
    setListItems(prevState => ({
      order: data.list,
      items: prevState.items
    }));
  });

  useOn('get_dnd_my_clients_new', async (data) => {
    console.log('get_dnd_my_clients', data);


    //Если это не админ и нет cid, тогда не обрабатываем
    if (rules.includes("admin") && !data.cid) {return}
    //Если чужая, тогда не обрабатываем
    if (rules.includes("admin") && data.cid && data.cid !== company_id) {return}
    //Если это не админ и нет uid, тогда не обрабатываем
    if (!rules.includes("admin") && !data.uid) {return}
    //Если не тот клиент, тогда не обрабатываем
    if (!rules.includes("admin") && data.uid && data.uid !== user_id) {return}


    let resp = {}; 
    await Promise.all(data.list.map(async (el) => {
      if (ds.descr.id === "my_clients") {
        if (el.data) {
          el.data = JSON.parse(el.data);
        } else {
          el.data = {};
        }
      }

      if (!resp[el.status]) resp[el.status] = {}; 
      resp[el.status][el.id] = el; 
      return el;
    }));

    setListItems(prevState => ({
      order: prevState.order,
      items: resp 
    }));

    showNotification({
      id: 'updateItems',
      type: 'success',
      message: 'Данные обновлены'
    });
  });

  useOn('get_dnd_and_order_' + ds.descr.id , async (data) => {
    if (ds.descr.id === "my_clients") {return}

    console.log("get_dnd_and_order", data)

    if (data.company_id !== company_id) {
      console.log('SKIP: wrong company');
      return;
    }


    let resp = {}; 
    await Promise.all(data.list.map(async (el) => {
      if (!resp[el.status]) resp[el.status] = {}; 
      resp[el.status][el.id] = el; 
      return el;
    }));

    console.log("RESP", resp)

    setListItems(
      {
        order: data.order,
        items: resp 
      }
    );

    showNotification({
      id: 'updateItems',
      type: 'success',
      message: 'Данные обновлены'
    });

    
  });

  useOn('get_dnd_' + ds.descr.id , async (data) => {
    if (ds.descr.id === "my_clients") {return}

    console.log("get_dnd_", data)

    if (data.company_id !== company_id) {
      console.log('SKIP: wrong company');
      return;
    }


    let resp = {}; 
    await Promise.all(data.list.map(async (el) => {
      if (!resp[el.status]) resp[el.status] = {}; 
      resp[el.status][el.id] = el; 
      return el;
    }));

    setListItems(prevState => ({
      order: prevState.order,
      items: resp 
    }));

    showNotification({
      id: 'updateItems',
      type: 'success',
      message: 'Данные обновлены'
    });

    ///обновление для обобщенных сделок
    let idx = data.list.findIndex((fel) => fel.id === state.id?.id) 
    if (idx > -1) {
      setState({...JSON.parse(JSON.stringify(state)), id: {id: data.list[idx].id, deals: data.list[idx].content.deals, products: data.list[idx].content.products}})
    }
    else {
      //Уже известно, что компания та
      //Если тип хранение но тикет не найден, значит была удалена последняя сделка от туда
      if (ds.descr.id === 'products_storage') {
        toggleDrawer('right', false, undefined, undefined, false, state.customEIds)()
      }
    }
  });

  useOn('get_tables_dnd_' + ds.descr.id , (data) => {
    console.log('get_tables_dnd_', data)
    if (data.company_id !== company_id)
    setListTables(data.data)
    showNotification({
      id: 'updateTables', // Уникальный идентификатор
      type: 'success', // Тип уведомления
      message: 'Данные обновлены' // Текст сообщения
    });

  });

  useOn('get_tabs_dnd_' + ds.descr.id , (data) => {
    console.log('get_tabs_dnd_', data)
    if (data.company_id !== company_id) return
    setTabsList(data.list)
    showNotification({
      id: 'updateTabs', // Уникальный идентификатор
      type: 'success', // Тип уведомления
      message: 'Данные обновлены' // Текст сообщения
    });

  });

  const { showNotification } = useLocalNotifications();

  // Хук для получения данных. Получение данных происходит через bridge прописанный в дескрипторе. 
  // Это позволяет ипользовать данный компонент как конструктор, описывая данные и поведение компонента внутри дескриптора.
  useEffect(()=>{
    const fetchData = async () => {
      try {
        setLoading(true);
        const responseData = await ds['start_get_'+ds.descr.id]()
        if (responseData) {
          setListTables(responseData.tables || [])
          setListItems({order:responseData.order || [], items: responseData.items || {}})
        }
        if (ds.descr.useTabs) {
          let tmp = await ds['tabs_get_'+ds.descr.id]()
          setTabsList(tmp)
        }
      } catch (err) {
      } finally {
        setLoading(false);
        setEmitFlag(false)
      }
    };
    console.log("STEP 1 dnd")
    setEmitFlag(true)
    fetchData()

    // ds['get_tables_' + ds.descr.id]()
    // ds['get_' + ds.descr.id]()
    // ds['get_order_' + ds.descr.id]()

    // setListItems({order:ds['get_order_' + ds.descr.id](), items:ds['get_' + ds.descr.id]()});

  }, [])


  // Индекс целевого элемента. В момент дропа тикета, используется для отслеживания положения падения относительно других тикетов в столбце.
  // За счёт этого происходит сохранение id тикета в нужной позиции внутри массива тикетов
  const [insertelement, setInsertelement] = useState({
    position: null, //Отслеживание позиции в виде: Перед / после целевого тикета
    idanchor: -1  //Индекс целевого тикета в массиве
  });

  const removeDuplicates =(arr) => {
    let res = []
    arr.map((el) => {
        if (typeof(el) === 'string' && !Number.isNaN(parseInt(el[0]))) {
            res.push(Number(el))
        }
        else {res.push(el)}
    })
    return [...new Set(res)];
  }

  // Функция апдейта массива тикетов. Используется для фиксации изменений в момент события дропа
  const handleUpdateList = async (id, status) => {
    if (true){ //Вот тут можно будет прописать кастомные условия
      let id_status = id.split('|'); // Данные о перетягиваемом тикете
      if (parseInt(id_status[0][0])) {//только если начинается с цифры
        id_status[0] = Number(id_status[0])//Возможно костыль, но где-то id становится строкой
      }
      // console.log("idstatus", id_status)
      let array = JSON.parse(JSON.stringify(listItems));  // Получение копии массива с тикетами. Копирование нужно для того чтобы при апдейте массива
                                                          // Не возникало ошибки. Апдейт должен проходить в рамках функции, отслеживаемой рендером
      console.log("TEEEEST0", JSON.parse(JSON.stringify(listItems)))
      let card = array.items[id_status[1]][id_status[0]]; // Данные о перетаскиваемой карточке
      // console.log("CARD", card)
      if (card) {
        //По факту, тут мы изем название именно самой верхней колонки, поэтому можем сплитануть статус
        console.log("status", status)
        let tmpSt = status.split('_')[0]
        let table = listTables.find((el) => el.status===tmpSt)
        console.log("listTables", listTables)
        console.log("table", table)
        // Изменение статуса (колонки к которой принадлежит тикет) через бридж в дескрипторе
        await ds['set_' + ds.descr.id](id_status[0], 'status', {status, show: table?.showStatus? {title: table.name, type:ds.descr.id, status}: {}, tableName: table.name}, 
          {type:ds.descr.title, status:table?.name}//объект для логов
        ); 
        
        //локальное изменение статуса
        _.set(card, 'status', status)
        let tempListItems = {...listItems.items}
        console.log("id_status", id_status)
        console.log("tempListItems", JSON.parse(JSON.stringify(tempListItems)))
        delete tempListItems[id_status[1]][id_status[0]]
        _.set(tempListItems[status], [id_status[0]], card)
        console.log("tempListItems[status]", tempListItems[status])

        console.log('insertelement', insertelement)
        setEmitFlag(true) // Установка флага обновления данных
        if (insertelement.idanchor !== -1) { // Проверка на наличие целевого тикета, после/перед которым нужно поместить перетаскиваемый
          console.log("DB1,s1", array.order)
          array.order.splice(array.order.findIndex(item => item === id_status[0]), 1);
          array.order.splice(insertelement.position==='afterend' ? array.order.findIndex(item => item === insertelement.idanchor) + 1 : array.order.findIndex(item=> item === insertelement.idanchor),0,id_status[0]);
          console.log("DB1,s2", array.order)
          setListItems({order:removeDuplicates(array.order), items: tempListItems});
          await ds['set_order_' + ds.descr.id](array.order); 
          // console.log("ORDER", listItems.order)
        }
        else{ // В случае отсутствия целевого тикета кладём перетаскиваевый в начало массива-в начало воронки
          console.log("DB2,s1", array.order)
          array.order.splice(array.order.findIndex(item => item === id_status[0]), 1);
          console.log("DB2,s1.1", array.order)
          array.order.unshift(id_status[0]);
          console.log("DB2,s2", array.order)
          console.log("last tempListItems", tempListItems)
          console.log("last array.order", array.order)
          console.log("TEEEEST1", {order:array.order, items: tempListItems})
          setListItems({order:removeDuplicates(array.order), items: tempListItems})
          await ds['set_order_' + ds.descr.id](array.order); 
        }
        setInsertelement({position:null, idanchor: -1})
      }  
    }
    else {
      showNotification({
        id: 'test', // Уникальный идентификатор
        type: 'warning', // Тип уведомления
        message: 'Тикет не можтет быть перенесен!' // Текст сообщения
      });
    }
    
  }

  const handleUpdateTicket = (id, field, value) => { 
    
    // 1. ИЩЕМ ТИКЕТ В ГЛУБИНЕ СТРУКТУРЫ
    let previousValue = undefined;
    
    // Пробегаемся по всем статусам (колонмам), чтобы найти тикет по ID
    for (const status in listItems.items) {
       if (listItems.items[status] && listItems.items[status][id]) {
           const card = listItems.items[status][id];
           // Используем lodash get для безопасного извлечения вложенных полей
           previousValue = _.get(card, field);
           break; // Нашли — выходим из цикла
       }
    }

    console.log("DEBUG: ID:", id, "Field:", field);
    console.log("DEBUG: Previous:", previousValue, "New:", value);

    // Дальше твой стандартный код...
    ds['set_' + ds.descr.id](id, field, value);

    // !!! ВАЖНО: Если ты делаешь локальный апдейт, нужно знать статус, 
    // чтобы правильно обновить стейт, иначе _.set(tempListItems[id]...) тоже не сработает корректно,
    // если структура {status: {id: data}}
    
    // Локальное изменение (исправленное под структуру)
    let tempListItems = _.cloneDeep(listItems.items); // Лучше сделать глубокую копию, чтобы React увидел изменения
    
    // Нужно найти путь для обновления и в локальном стейте тоже
    for (const status in tempListItems) {
        if (tempListItems[status][id]) {
             _.set(tempListItems[status][id], field, value);
             break;
        }
    }
    
    setListItems({order:listItems.order, items: tempListItems})

    if(value){
      post("Logs/create", {
              deal_id:id,
              user_type:"ful",
              user_id,
              type: "dnd_date",
              data: {
                field: field,
                oldValue: previousValue, // <--- Записываем найденное значение
                newValue: value
              }
            })
    }
  }


  /** @type {[any, Function]} */
  const [state, setState] = useState({
    right: false,
    id: 0,
    customEIds: undefined,
    type: 'classic'
  });

  const toggleDrawer = (anchor, open, idcard, defaultTab = undefined, mg = false, customEIds = undefined) => (event) => {
    if (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift')) {
      return;
    }
    
    const performToggle = () => {
      let type = 'classic'
      if (defaultTab) {
        eids.descr.defaultTab = defaultTab;
      }
      console.log("mg", mg)
      if (!mg) {
        eids.descr.tabs = eids.descr.tabs.filter((fel) => fel !== 'moveGuide');
      } else {
        // if (!eids.descr.tabs.includes("moveGuide")) {
        //   eids.descr.tabs.push('moveGuide');
        // }
        type = 'mg'
      }
      const finalId = !open ? null : idcard;
      setUnsavedChanges(false); 
      
      // @ts-ignore
      setState({ [anchor]: open, id: finalId, customEIds, type});
    };

    if (!open && unsavedChanges) {
      ShowModal(
        'Несохраненные изменения',
        <div>У вас есть несохраненные данные. Вы уверены, что хотите закрыть шторку?</div>,
        async () => {
          performToggle();
        }
      );
      return;
    }
    performToggle();
  };

  // Объект фильтра, использзуется для фильтрации отображаемых карточек. Выполнен ввиде хука, потому что необходимо ререндерить страницу для отображения изменений
  /** @type {[any, Function]} */ 
  const [filtername, setFilterName] = useState({name: null, timeStart: null, timeEnd: null, status: [], dateStart: null, dateEnd: null});

  // Хук для изменения фильтра
  const setFilter = ({name = null, timeStart = null, timeEnd = null, status = null, dateStart = null, dateEnd = null}) =>{
    console.log("setFilter", name)
    let filter = JSON.parse(JSON.stringify(filtername));
    if (name != null){
      if (name === '')
        filter.name = null
      else
      // @ts-ignore
      filter.name = name.toLowerCase();
    }
    if (timeStart != null){
      if (timeStart === '')
        filter.timeStart = null
      else
      filter.timeStart = timeStart;
    }
    if (timeEnd != null){
      if (timeEnd === '')
        filter.timeEnd = null
      else
      filter.timeEnd = timeEnd;
    }
    if (dateStart != null){
      if (timeEnd === '')
        filter.dateStart = null
      else
      filter.dateStart = dateStart;
    }
    if (dateEnd != null){
      if (dateEnd === '')
        filter.dateEnd = null
      else
      filter.dateEnd = dateEnd;
    }
    if (status){
      if (status === 'Clear')
        filter.status = []
      else
      filter.status = status;
    }
    setFilterName(filter);
  }

  // Переменная для отслеживания состояния перетягивания тикета
  const [isDragging, setIsDragging] = useState(false)

  /////////// Данные ссылки создаются на верхнем уровне для общего доступа внутри воронок
  /////////// Логика обработки следующая. При начале перетягивания тикета мы скрываем фактический и создаём клона, который является отображаемым. Именно на них тут существуют ссылки
  /////////// Отображаемый "теневой клон" перемещается по колонкам и в момент дропа мы убираем клона, изменяем массив, предназначенный для тикетов и рендерим окно с новым расположением.
  /////////// После чего ссылки на компоненты опустошаются до следующей итерации
  // Ссылка на отображаемый клон тикета
  const cloneItemRef = useRef(null);
  // Ссылка на перетягиваемый тикет
  const dragItemRef = useRef(null);
  ///////////

  // Ссылка на таргет колонку
  const selectedColumnRef = useRef(null);
  // Обработчик изменения флага перетаскивания
  const handleDragging = (dragging) => setIsDragging(dragging)

  // Получение воронки (колонки, воронки)
  const Container = ds.descr.items[1].formatter;

  const preSetListTables = (data) => {
    console.log("change table", data)
    setListTables(data.filter((fel) => !fel.del))
    ds['set_tables_' + ds.descr.id](data);
  }

  //Добавляет новую вкладку
  const preSetListTabs = (list) => {
    console.log("preSetListTabs", list)
    setTabsList(list)
    ds['set_tabs_' + ds.descr.id](list);
  }


  const renderThumbHorizontal = ({ style, ...props }) => {
    const thumbStyle = {
        ...style,
        backgroundColor: 'rgba(68, 68, 68, 0.5)',
        height: '20px',
        cursor: 'pointer'
    };
    return <div style={thumbStyle} {...props} />;
    };

  const renderView = ({ style, ...props }) => {
    const viewStyle = {
        ...style,
        overflowY: 'hidden', 
        overflowX: 'scroll', 
    };
    return <div style={viewStyle} {...props} />;
};

  const changeTab = (e, t) => {
    console.log(t)
    setTab(t)
    localStorage.setItem("AST", t)
  }

  const scrollFlag = useRef(false)
  const scrolref = useRef(null)
  const startX = useRef(null)

  const startHandScroll = (e) => {
    startX.current = e.clientX;
    scrollFlag.current = true;
  }

  const stopHandScroll = (e) => {
    startX.current = null
    scrollFlag.current = false;
  }

  const handScroll = (e) => {
    if (scrollFlag.current) {
      // @ts-ignore
      scrolref.current.scrollLeft(scrolref.current.getValues().scrollLeft-(e.clientX - startX.current)*0.02)
    }
  }

  console.log("tab list", tabList)

  if(ds.descr?.items && listItems)
    return (
      <>
      <
// @ts-ignore
      Helmet>
          <title>{ds.descr.title}</title>
      </Helmet>
      {/* <Update
        onChangeTicket={setListItems}
        onChangeTable={setListTables}
      > */}
          {/* Послкьку дескриптор, это вещь универсальная, обращения проходят по заранее подготовленному сценарию.
          0 элемент это верхнее меню, оно содежрит фильтры, общие кнопки и прочие вещи, не относящиеся на прямую к dnd */}
        {ds.descr.items[0].formatter({
          ds:ds.descr.items[0],
          setFilterName:setFilter,
          setListItems:setListItems,
          setEmitFlag:setEmitFlag,
          listItems:listItems,
          listTables:listTables,
          setListTables:preSetListTables,//setListTables
          setListTabs:preSetListTabs,
          listTabs:tabList
        })}
        <div style={{
            whiteSpace: 'nowrap', 
            height:'89%',
            position: 'relative', 
            paddingTop: "0px",
            margin: "1% 1% 2% 1%",

          }}
        > 
          <div
            style={{
                width: '100%',
                height:'100%',
            }}
          >
            {ds.descr.useTabs && 
              <Box sx={{ width: '100%'}}>      
                <Tabs value={tab} onChange={changeTab}
                  sx={{
                    "& .MuiTabs-indicator": {
                        display: "none"
                    },
                    backgroundColor: "#e6e6e6",
                    height: "30px",
                    minHeight: "30px",
                    marginBottom: "20px",
                    paddingLeft: "10px"
                  }}
                >
                    {
                      // @ts-ignore
                      tabList.filter((fel) => !fel.del).map((t) => <DNDTab label={`Стеллаж ${t.title.toUpperCase()}`} value={t.name} />)
                    }
                </Tabs>
              </Box>
            }
            {/* Тут происходит map массива столбцов (воронок) и их отображение в соответствии с помещённым в дескриптор элементом */}
            <div style={{width: "100%", height: "100%", overflow: 'hidden'}}
              // onMouseMove={handScroll}
              // onMouseDown={startHandScroll}
              // onMouseUp={stopHandScroll}
            >
              {loading? <Loading></Loading>:
              <Scrollbars ref={scrolref} style={{height: "100%"}} renderThumbHorizontal={renderThumbHorizontal} 
                renderThumbVertical={props => <div {...props} style={{display: 'none'}}/>} renderView={renderView}
              >
                {
                  (ds.descr.useTabs? listTables.filter((fel) => fel.tab === tab): listTables).map(container => {
                      return (<Container
                          ds={ds.descr.items[1]}
                          color={container.color}
                          colorcircule={container.colorcircule}
                          items={listItems.order}
                          name={container.name}
                          status={container.status}
                          showStatus={container.showStatus}
                          showItems={listItems.items}
                          key={container.name}
                          filtername={filtername}
                          isDragging={isDragging}
                          handleDragging={handleDragging}
                          handleUpdateList={handleUpdateList}
                          handleUpdateTicket={handleUpdateTicket}
                          toggleDrawer={toggleDrawer}
                          setInsertelement={setInsertelement}
                          setListTables={preSetListTables}//setListTables
                          listTables={listTables}
                          setEmitFlag={setEmitFlag}
                          setListItems={setListItems}
                          dragItemRef={dragItemRef}
                          selectedColumnRef={selectedColumnRef}
                          cloneItemRef={cloneItemRef}
                          // @ts-ignore
                          currentTab={tabList.find((fel) => fel.name === tab)}
                      />
                    )
                  })
                }
              </Scrollbars>
              }
            </div>
            <Drawer
              anchor='right'
              open={state['right'] && state.type === 'classic'}
              onClose={toggleDrawer('right', false, undefined, undefined, false, state.customEIds)} // Тут уже используется обновленная логика
            >
              <ElementInfo 
                ds={state.customEIds? getDataSource(state.customEIds): eids} 
                data={state.id} 
                // @ts-ignore
                setChanged={setUnsavedChanges}
                // @ts-ignore
                onClose={toggleDrawer('right', false, undefined, undefined, false, state.customEIds)}
              />
            </Drawer>
            <MoveGuideDialog deal_id={state.id} open={state['right'] && state.type === 'mg'} onClose={toggleDrawer('right', false, undefined, undefined, false, state.customEIds)}/>
          </div>
        </div>
        

      {/* </Update> */}
      </>
    )
    else return(<div/>)
}

// Вызов различных drag and drop меню с нужными дескрипторами
export const NewClientDragEndDrop = () => {
  // const ds = useMemo(() => getDataSource('new_clients'), []);
  const ds = getDataSource('new_clients')
  return <DragAndDrop ds={ds}/>
}

export const PicUpDragEndDrop = () => {
  // const ds = useMemo(() => getDataSource('pik_goods'), []);
  const ds = getDataSource('pik_goods')
  console.log("dnd ds0", ds)
  return <DragAndDrop ds={ds}/>
}

export const MovingDragEndDrop = () => {
  // const ds = useMemo(() => getDataSource('moving_deals'), []);
  const ds = getDataSource('moving_deals')
  console.log("dnd ds", ds)
  return <DragAndDrop ds={ds}/>
}

export const MyCliDragEndDrop = () => {
  // const ds = useMemo(() => getDataSource('my_clients'), []);
  const ds = getDataSource('my_clients')
  console.log("dnd ds", ds)
  return <DragAndDrop ds={ds}/>
}

export const AddressableStorage = () => {
  // const ds = useMemo(() => getDataSource('adrr_storage'), []);
  const ds = getDataSource('adrr_storage')
  return <DragAndDrop ds={ds}/>
}

export const ProductsStorage = () => {
  // const ds = useMemo(() => getDataSource('products_storage'), []);
  const ds = getDataSource('products_storage')
  return <DragAndDrop ds={ds}/>
}

export const ProductsShipment = () => {
  // const ds = useMemo(() => getDataSource('products_shipment'), []);
  const ds = getDataSource('products_shipment')
  return <DragAndDrop ds={ds}/>
}